(function() { window.GUID_e8f40312_e3c8_43a3_93ef_2160007f0ba4 = { getGuid: function() { return "e8f40312-e3c8-43a3-93ef-2160007f0ba4"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class GridView extends Controls.ControlBase {
            OnDispose() {
                this.$gridViewContainer.off("mousedown." + this.UniqueNamespace);
                CS.DOM.$body
                    .off("mousemove." + this.UniqueNamespace)
                    .off("mouseup." + this.UniqueNamespace);
                this.$Control.remove();
                if (CS.Controls.FixedHeadersHelper.Instance) {
                    CS.Controls.FixedHeadersHelper.Instance.Start();
                }
                CS.DOM.$win.off(`resize.gridView${this.controlId}`, () => {
                    CS.Lag("resizeGridView", 150, () => {
                        this.update();
                    });
                });
                CS.Controls.FixedHeadersHelper.RemovePopupHeaderHelpers();
            }
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
                this.$control = $("#" + params[0]); //contient le Id
                let me = this;
                me.mouseDownScrollPosition = new CS.Point();
                me.startDragPoint = new CS.Point();
                me.lastHorizontalScroll = 0;
                me.$Control.wrap("<div></div>");
                me.$Control.attr("id", null);
                let classToMove = me.$Control.attr("class");
                me.$Control.attr("class", null);
                me.$gridViewContainer = me.$Control.parent();
                me.$gridViewContainer.attr("id", me.ControlId);
                me.$gridViewContainer.attr("class", classToMove);
                me.$scrollableTable = me.$Control;
                me.$scrollableTable.addClass("scrollable-table");
                me.$control = me.$gridViewContainer;
                me.$scrollableTable.wrap('<div class="scrollable-table-container"></div>');
                me.$scrollableTableContainer = me.$scrollableTable.parent(); //import sinon, l'instance n'est pas la meme
                me.createFixedLeftHeader();
                me.createFixedTopLeftHeader();
                me.SetFixedHeader();
                //FixedHeadersHelper.ActivateFixedHeaderFeature({
                //    Section: this,
                //    Id: me.ControlId,
                //    OnCloneHeader: () => me.createFixedTopHeader(),
                //    $HeaderReference: this.$scrollableTable.find('thead'),
                //    $ContainerReference: this.$gridViewContainer,
                //    $ContainerWithoutScrollBarReference: this.$scrollableTable,
                //    OnBeforeShowFixedHeader: () => me.bindUnbindHorizontalScrolling(true),
                //    OnBeforeHideFixedHeader: () => me.bindUnbindHorizontalScrolling(false),
                //});
                me.$gridViewContainer = me.$Control.parent();
            }
            SetFixedHeader() {
                const me = this;
                const inPopup = me.$control.closest('.popup').length > 0;
                Controls.FixedHeadersHelper.ActivateFixedHeaderFeature({
                    Section: this,
                    Id: me.ControlId,
                    OnCloneHeader: () => me.createFixedTopHeader(),
                    $HeaderReference: this.$scrollableTable.find("thead"),
                    $ContainerReference: this.$gridViewContainer,
                    $ContainerWithoutScrollBarReference: this.$scrollableTable,
                    OnBeforeShowFixedHeader: () => me.bindUnbindHorizontalScrolling(true),
                    OnBeforeHideFixedHeader: () => me.bindUnbindHorizontalScrolling(false),
                    OnAfterShow: () => {
                        me.Trigger(GridView.EventNames.FixedHeaderToggled, { jqueryEventObject: null, data: {} });
                    },
                    inPopup: inPopup,
                    $topBar: inPopup ? me.$control.closest('.popup').find(".popup-header") : undefined
                });
            }
            OnBindEvents() {
                let me = this;
                me.$gridViewContainer
                    .offon("mousedown." + this.UniqueNamespace, function (e) {
                    let scroll = me.getScroll();
                    me.mouseDown = true;
                    me.mouseDownScrollPosition.X = scroll.X;
                    me.startDragPoint.X = e.clientX;
                })
                    .offon("mouseleave." + this.UniqueNamespace, function () {
                    me.mouseDown = false;
                });
                me.$gridViewContainer.offon("mouseup.sort" + this.UniqueNamespace, "th", function (e) {
                    let th = e.currentTarget;
                    me.sortColumn(th);
                });
                CS.DOM.$body
                    .offon("mousemove." + this.UniqueNamespace, function (e) {
                    if (me.mouseDown) {
                        if (Math.abs(e.clientX - me.startDragPoint.X) > 3 ||
                            Math.abs(e.clientY - me.startDragPoint.Y) > 3) {
                            e.preventDefault();
                            me.$scrollableTableContainer.scrollLeft(me.mouseDownScrollPosition.X - (e.clientX - me.startDragPoint.X));
                        }
                    }
                })
                    .offon("mouseup." + this.UniqueNamespace, function (e) {
                    me.mouseDown = false;
                });
                CS.DOM.$win.offon(`resize.gridView${this.controlId}`, () => {
                    CS.Lag("resizeGridView", 150, () => {
                        this.update();
                    });
                });
            }
            update() {
                CS.Helper.log('gridview', `Update gridview: ${this.controlId}`);
                if (CS.Controls.FixedHeadersHelper.Instance) {
                    CS.Controls.FixedHeadersHelper.Instance.RefreshAllIFixedHeaders();
                }
            }
            AppendNewGridContent($gridView) {
                let me = this;
                let fixedHeaderColumnsIndex = me.$scrollableTable.data("fixedcolumns");
                let containFixedColumns = fixedHeaderColumnsIndex != null && fixedHeaderColumnsIndex.length > 0;
                let rows = $gridView.find("tbody tr");
                let $tbodyLeftFixed = me.$fixedLeftHeaderTable.find("tbody");
                let $tbody = me.$scrollableTable.find("tbody");
                for (let i = 0; i < rows.length; i++) {
                    let row = rows[i];
                    let newRow = $(row.cloneNode(false));
                    if (containFixedColumns) {
                        let splitted = fixedHeaderColumnsIndex.toString().split(",");
                        let newLeftFixedRow = $(row.cloneNode(false));
                        for (var y = 0; y < splitted.length; y++) {
                            let index = parseInt(splitted[y]);
                            let cell = row.cells[index];
                            let newCell = $(cell.cloneNode(true));
                            newLeftFixedRow.append(newCell);
                        }
                        $tbodyLeftFixed.append(newLeftFixedRow);
                    }
                    for (var c = 0; c < row.cells.length; c++) {
                        let cell = row.cells[c];
                        let newCell = $(cell.cloneNode(true));
                        newRow.append(newCell);
                    }
                    $tbody.append(newRow);
                }
                CS.Controls.FixedHeadersHelper.Instance.Start();
            }
            bindUnbindHorizontalScrolling(bind) {
                let me = this;
                if (bind) {
                    me.$scrollableTableContainer.offon("scroll." + this.UniqueNamespace, function (e) {
                        e.preventDefault();
                        e.stopImmediatePropagation();
                        requestAnimationFrame(function () {
                            let currentLeft = -me.$scrollableTableContainer.scrollLeft();
                            if (me.lastHorizontalScroll != currentLeft) {
                                me.lastHorizontalScroll = currentLeft;
                                me.$fixedTopHeaderTable.css("left", currentLeft);
                            }
                        });
                    });
                }
                else {
                    me.$scrollableTableContainer.off("scroll." + this.UniqueNamespace);
                }
            }
            getScroll() {
                let scroll = new CS.Point();
                scroll.X = this.$scrollableTableContainer.scrollLeft();
                scroll.Y = this.$scrollableTableContainer.scrollTop();
                return scroll;
            }
            createFixedTopHeader() {
                this.lastHorizontalScroll = -this.$scrollableTableContainer.scrollLeft();
                let $fixedTopHeaderTable = $('<table class="fixed-top-header-table"></table>');
                $fixedTopHeaderTable.append(this.$scrollableTable.find("thead").clone(false, false));
                $fixedTopHeaderTable.css({
                    left: this.lastHorizontalScroll,
                });
                this.$fixedTopHeaderTable = $fixedTopHeaderTable;
                let $container = $('<div class="fixed-top-left-and-top-container"></div>');
                $container.append(this.$fixedTopHeaderTable);
                if (this.$fixedTopLeftHeaderTable) {
                    $container.append(this.$fixedTopLeftHeaderTable.clone(false, false));
                }
                return $container;
            }
            createFixedTopLeftHeader() {
                if (this.$fixedLeftHeaderTable) {
                    this.$fixedTopLeftHeaderTable = this.$fixedLeftHeaderTable.clone(false);
                    this.$fixedTopLeftHeaderTable
                        .addClass("fixed-top-left-header-table")
                        .removeClass("fixed-left-header-table");
                    this.$fixedTopLeftHeaderTable.find("tbody").remove();
                    this.$fixedTopLeftHeaderTable.appendTo(this.$gridViewContainer);
                }
            }
            createFixedLeftHeader() {
                let me = this;
                let fixedHeaderColumnsIndex = me.$scrollableTable.data("fixedcolumns");
                let fixedHeaderColumnsIndexString = "";
                if (fixedHeaderColumnsIndex != null &&
                    fixedHeaderColumnsIndex.length > 0) {
                    fixedHeaderColumnsIndexString = fixedHeaderColumnsIndex.toString();
                    let splitted = fixedHeaderColumnsIndexString.split(",");
                    let $fixedLeftHeaderTable = $('<table class="fixed-left-header-table"><thead><tr></tr></thead><tbody></tbody></table>');
                    let $thead = $fixedLeftHeaderTable.find("thead");
                    let $theadTr = $thead.find("tr");
                    let $tbody = $fixedLeftHeaderTable.find("tbody");
                    for (let i = 0; i < splitted.length; i++) {
                        let index = parseInt(splitted[i]) + 1;
                        let ths = me.$scrollableTable.find("th:nth-child(" + index + ")");
                        let clonedHeaderCells = ths.clone(false, false);
                        $theadTr.append(clonedHeaderCells);
                    }
                    let rows = me.$scrollableTable.find("tbody tr");
                    for (let i = 0; i < rows.length; i++) {
                        let row = rows[i];
                        let newRow = $(row.cloneNode(false));
                        for (var y = 0; y < splitted.length; y++) {
                            let index = parseInt(splitted[y]);
                            let cell = row.cells[index];
                            let newCell = $(cell.cloneNode(true));
                            newRow.append(newCell);
                        }
                        $tbody.append(newRow);
                    }
                    $fixedLeftHeaderTable.appendTo(me.$gridViewContainer);
                    me.$fixedLeftHeaderTable = $fixedLeftHeaderTable;
                }
            }
            sortColumn(th) {
                if (this.lastScrolledHeader && this.lastScrolledHeader != th) {
                    this.lastScrolledHeader.classList.remove("asc");
                    this.lastScrolledHeader.classList.remove("desc");
                }
                this.lastScrolledHeader = th;
                let sortComparer = 1;
                if (th.classList.contains("asc")) {
                    th.classList.remove("asc");
                    th.classList.add("desc");
                    sortComparer = -1;
                }
                else if (th.classList.contains("desc")) {
                    th.classList.remove("desc");
                    th.classList.add("asc");
                }
                else {
                    th.classList.add("asc");
                }
                let colIndex = th.cellIndex;
                let refRows = this.$scrollableTableContainer.find("table tbody tr");
                let containFixedRow = this.$fixedLeftHeaderTable != null;
                let fixedRows = containFixedRow
                    ? this.$fixedLeftHeaderTable.find("tbody tr")
                    : null;
                let toSortRows = new Array();
                for (var i = 0; i < refRows.length; i++) {
                    toSortRows.push({
                        index: i,
                        refRow: refRows[i],
                        fixedRow: containFixedRow
                            ? fixedRows[i]
                            : null,
                    });
                }
                let $sortedRows = toSortRows.sort(this.compareRowsV2(colIndex, sortComparer));
                let $refRows = $sortedRows.map(function (e) {
                    return e.refRow;
                });
                this.$scrollableTableContainer.find("table tbody").append($refRows);
                if (containFixedRow) {
                    let $fixedRows = $sortedRows.map(function (e) {
                        return e.fixedRow;
                    });
                    this.$fixedLeftHeaderTable.find("tbody").append($fixedRows);
                }
            }
            compareRowsV2(colIndex, sortComparer) {
                return function (a, b) {
                    let rowA = a.refRow;
                    let rowB = b.refRow;
                    let cellA = rowA.cells[colIndex].innerText.toLowerCase().trim();
                    let cellB = rowB.cells[colIndex].innerText.toLowerCase().trim();
                    let cellANum = parseFloat(cellA);
                    let cellBNum = parseFloat(cellB);
                    if (!isNaN(cellANum) && !isNaN(cellBNum)) {
                        cellA = cellANum;
                        cellB = cellBNum;
                    }
                    if (cellA > cellB) {
                        return sortComparer;
                    }
                    else if (cellA < cellB) {
                        return -sortComparer;
                    }
                    else {
                        return 0;
                    }
                };
            }
        }
        Controls.GridView = GridView;
        (function (GridView) {
            class Events {
                static FixedHeaderToggled(param) {
                    Controls.RegisterEvent(GridView, EventNames.FixedHeaderToggled, param);
                }
            }
            GridView.Events = Events;
            class EventNames {
            }
            EventNames.FixedHeaderToggled = "fixed-header-toggled";
            GridView.EventNames = EventNames;
        })(GridView = Controls.GridView || (Controls.GridView = {}));
        //export class GridViewV2 extends ControlBase {
        //    private $control: JQuery;
        //    public get $Control(): JQuery {
        //        return this.$control;
        //    }
        //    private controlId: string;
        //    public get ControlId(): string {
        //        return this.controlId;
        //    }
        //    private fixedColumns: number = 0;
        //    protected OnControlInstantiation(params: any[]) {
        //        this.controlId = params[0];
        //        this.$control = $('#' + params[0]);
        //        this.fixedColumns = params[1];
        //        this.$control.wrap('<div class="grid-view-v2-container"></div>');
        //    }
        //    protected OnBindEvents() {
        //        throw new Error("Method not implemented.");
        //    }
        //    protected OnDispose() {
        //        throw new Error("Method not implemented.");
        //    }
        //}
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=gridview.js.map
